import './common/rem'
import Vue from 'vue'
import App from './App.vue'
import store from './store/index'
import {
  router
} from './router'
// import { SALE_END, SALE_BEGIN, BOOK_END } from './store/const';
// import { WZUtils } from './common/globals';
// import { now } from './common/utils';

// function stopTimer(vm) {
//   if(vm.timer) {
//     clearInterval(vm.timer)
//   }
//   vm.timer = null
// }
import {
  mapState,
  mapActions,
  mapMutations,
  mapGetters
} from 'vuex';

import("./assets/css/app.css");
import('./assets/css/match.css');
import('./assets/css/reality.css');
import Stat from './common/stat';
import components from './components/index.js';
import { SET_NAV } from './store/mutation-types';
import { trim, time2text } from './common/utils';
// import WzNavbar from './components/wz-navbar.vue';
// import TimerNum from './components/timer-num.vue';
// import ButtonBuy from './components/goods-button-buy.vue';
// import PreGoodsList from './components/pre-goods-list.vue';

Vue.use(components)
// Vue.component('wz-navbar', WzNavbar)
// Vue.component('timer-num', TimerNum)
// Vue.component('goods-button-buy', ButtonBuy)
// Vue.component('pre-goods-list', PreGoodsList)
// alert(process.env.VUE_APP_CDN_HOST)

// filters
Vue.filter('trim', trim)
Vue.filter('time2text', time2text)

new Vue({
  router,
  store,
  el: '#kApp',
  render: h => h(App),
  computed: {
    ...mapState(['tabIndex']),
    ...mapGetters(['isValidUser'])
  },
  methods: {
    ...mapActions(['loadConfig', 'timerStart', 'timerStop', 'loadMyInfo','loadMyDetail']),
    ...mapMutations([SET_NAV])
  },
  async created() {

    // 路由跳转， 底导航条设置
    const {$route} = this
    const afterEach = (to) => {
      const {meta} = to
      // if(/\/my/.test(path) && !this.isValidUser) {
      //   // alert(path)
      //   this.$router.replace('/index')
      //   return;
      // }
      this[SET_NAV](meta.tabIndex)
      const appName = /\/(reality|match)\/?/.test(to.path) ? RegExp.$1 : 'match'
      let className = document.body.className || ''
      className = className.replace(/\s*\b(?:reality|match)\b/g, '') + ' ' + appName
      className = trim(className)
      document.body.className = className
      // console.log(className);
      // console.log(meta);
    }
    this.$router.afterEach(afterEach);
    if($route.meta) {
      afterEach($route)
      // this[SET_NAV]($route.meta.tabIndex)
    }

    // 统计代码


    Stat.init({router: this.$router});

    await this.loadConfig()
    const uinfo = await this.loadMyInfo()
    if (uinfo && uinfo.uid > 0) { // 已登录：自动加载我的进度
      await this.loadMyDetail()
    }
    this.timerStart({})
  },
  // amounted() {
  //   this.timerStart({})
  // },
  beforeDestroy() {
    this.timerStop()
  }
})
